import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Security Interceptor
 * Adds security headers and handles security-related errors
 */
export const securityInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Clone request and add security headers
  const secureReq = req.clone({
    setHeaders: {
      'X-Requested-With': 'XMLHttpRequest',
      // Add other security headers as needed
    },
  });

  return next(secureReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle security-related errors
      if (error.status === 401) {
        // Token expired or invalid - try to refresh
        authService.refreshAuthToken().catch(() => {
          // If refresh fails, logout will be handled by auth guard
        });
      }

      // Sanitize error messages to prevent XSS
      if (error.error && typeof error.error === 'object') {
        // Don't expose internal error details in production
        const isDevelopment = !window.location.hostname.includes('web.app') && 
                              !window.location.hostname.includes('firebaseapp.com');
        
        if (!isDevelopment && error.error.error) {
          // In production, only show generic error messages
          error.error.error = 'An error occurred. Please try again.';
        }
      }

      return throwError(() => error);
    })
  );
};

